import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function RedirectTo({ to }) {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(to, { replace: true });
  }, [to, navigate]);
  return null;
}
